import { filterNonNullValues } from '@/lib/utils'
import Adversaries from '@/views/adversaries'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/adversaries/')({
    component: Adversaries,
    validateSearch: (search) => filterNonNullValues({
        page: search.page ? Number(search.page) : 0,
        page_size: search.page_size ? Number(search.page_size) : 10,
        ordering: typeof search.ordering === 'string' ? search.ordering : null,
        search: typeof search.search === 'string' ? search.search : null,
        client_type: typeof search.client_type === 'string' ? search.client_type : null,
        id_type: typeof search.id_type === 'string' ? search.id_type : null,
    }),
})
